import request from "@/utils/request";
import Qs from "qs";

// 意见反馈

// 意见反馈列表
export function lists(data) {
  return request({
    url: "/feedback/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 意见反馈回复
export function reply(data) {
  return request({
    url: "/feedback/reply",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 意见反馈详情
export function info(data) {
  return request({
    url: "/feedback/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
